export enum ToggleButtonView {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal',
	HORIZONTAL_MULTILINE = 'horizontalMultiline',
}
